const VehicleManagementIndex = () => import("@/views/vehicles/VehicleManagementIndex.vue")

export default [
    {
        path: "/admin/vehicles",
        name: "VehicleManagement",
        component: VehicleManagementIndex,
        meta: {
            label: "Vehicle Management",
            description: "Manage vehicle brands and models"
        }
    }
]
